<template>
  <div class="card-body" v-if="devices.length > 0">
      <h5 class="card-title">Vklopljeno odtaljevanje</h5>
      <ul>
        <li v-for="d in devices" :key="d.id">
          <a href="#" @click.prevent="$router.push({ name: 'DeviceEdit', params: { deviceId: d.id } })">{{ d.label }} ({{ d.deviceNumber }}) </a>{{ d.defrostingNote }}
        </li>
      </ul>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { listEntitiesAsync } from "../api"
import { useAuth } from "../composition-api/useAuth"

defineOptions({ name: "DevicesListCard" })

const { fetchAuthAsync } = useAuth()
const devices = ref([])

onMounted(async () => {
  devices.value = await listEntitiesAsync(fetchAuthAsync, "Devices?isDefrosting=true")
})
</script>
